import { getCookieValue } from 'components/analytics/utils';
import { ANON_ID_COOKIE, CHIME_USER_ID_COOKIE } from 'utils/cookies';
import { isBrowser } from 'utils/environment';

declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

/**
 * Segment events forwarded directly into the GTM dataLayer. The GTM-N3Z9ZNR
 * container keys its custom-event triggers on these names.
 *
 * These events are ALSO sent through Segment with the Segment->GTM destination
 * disabled (see libs/segment.ts), so GTM receives each one exactly once via the
 * dataLayer while every other Segment destination keeps receiving it.
 */
export const GTM_DESTINATION_EVENTS = new Set([
  'FAQ Arrow Clicked',
  'Floating Disclaimer Shown',
  'Landing Page Email Filled',
  'Landing Page Experiment Viewed',
  'Lead Generation Interaction Captured',
  'Login Link Tapped',
  'Module Viewed',
  'Scroll Depth',
  'Slider Bar Clicked',
  'Visitor ID Set',
]);

// Match Segment's GTM destination payload: include `userId` only when the
// caller is identified, never when anonymous. The @1debit/analytics SDK writes
// the identified user ID to `chime_user_id` on identify (scoped *.chime.com),
// so reading the cookie at push time picks up any user identified anywhere on
// the chime.com surface — at parity with what Segment forwards today.
export function pushGtmEvent(eventName: string, properties: object = {}): void {
  if (!isBrowser() || !eventName) return;

  const userId = getCookieValue(CHIME_USER_ID_COOKIE);
  const dataLayer = (window.dataLayer ||= []);
  dataLayer.push({
    ...(userId ? { userId } : {}),
    ...properties,
    segmentAnonymousId: getCookieValue(ANON_ID_COOKIE),
    event: eventName,
  });
}
